
import {
    Card,
    CardHeader,
    CardBody,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Button,
    Col,
} from "reactstrap";
import { useFormik } from "formik";
import { useState, useEffect, forwardRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { httpRequest } from "utils/httpRequest";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";


const ForwardedInput = forwardRef(({ value, onChange, ...rest }, ref) => (
    <Input
        innerRef={ref}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        {...rest}
    />
));





const AddUser = () => {
    const { id } = useParams();

    const navigate = useNavigate()
    const [initialData, setInitialData] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required("First name is required"),
        last_name: Yup.string().required("Last name is required"),
        email: Yup.string().email("Invalid email").required("Email is required"),
        phone: Yup.string()
            .required("Phone number is required") // ✅ show error when empty
            .test("is-valid-phone", "Invalid phone number", value =>
                value ? isValidPhoneNumber(value) : false
            )

    });

    const formik = useFormik({
        initialValues: {
            first_name: "",
            last_name: "",
            email: "",
            phone: ""
            // password: ""

        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const response = await httpRequest(
                    `admin/updateUser/${id}`,
                    "PUT",
                    {
                        firstName: values.first_name,
                        lastName: values.last_name,
                   
                        email: values.email,
                        phoneNumber:values.phone
                    },
                    {},
                    true,
                    true
                );

                if (response?.code === 200) {
                    toast.success("User updated successfully");
                    formik.resetForm({
                        values: {
                            first_name: "",
                            last_name: "",
                            email: "",
                            phone:""
                        }
                    });
                    navigate("/admin/user-management")
                } else {
                    toast.error(response?.message || "Something went wrong");
                }
            } catch (error) {
                console.log(error);

            }
        }
    });



    const fetchUserDataForEdit = async () => {
        try {

            const response = await httpRequest(
                `admin/getUser/${id}`,
                "GET",
                {

                },
                {
                    // page: page,
                    // limit: pageLimit
                },
                true,
                false
            );

            if (response?.code === 200) {
                console.log("reed",response)
                const data = response?.data
                formik.resetForm({
                    values: {
                        first_name: data.firstName,
                        last_name: data?.lastName,
                        email: data?.email,
                        phone:data?.phoneNumber
                    }
                })

                // setTotal(response?.total);
                // setActivePage(response?.page);
                // setLimit(response?.limit);


            }

        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchUserDataForEdit()
    }, [])



    return (
        <Col lg="8" md="8" className="mx-auto mt-4">
            <Card className="bg-secondary shadow border-0">
                <CardHeader className="bg-transparent pb-3">
                    <div className="text-muted text-center mt-2 mb-3">
                        <small>Update User</small>
                    </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-4">
                    <Form onSubmit={formik.handleSubmit}>
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-single-02" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="First Name"
                                    type="text"
                                    name="first_name"
                                    value={formik.values.first_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}

                                />
                            </InputGroup>
                            {formik.touched.first_name && formik.errors.first_name && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.first_name}
                                </div>
                            )}
                        </FormGroup>
                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-single-02" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Last Name"
                                    type="text"
                                    name="last_name"
                                    value={formik.values.last_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}

                                />
                            </InputGroup>
                            {formik.touched.last_name && formik.errors.last_name && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.last_name}
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-email-83" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    placeholder="Your Email"
                                    type="email"
                                    name="email"
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}

                                />
                            </InputGroup>
                            {formik.touched.email && formik.errors.email && (
                                <div className="text-danger small mt-1">
                                    {formik.errors.email}
                                </div>
                            )}
                        </FormGroup>


                        <PhoneInput
                            id="phone"
                            name="phone"
                            style={{ marginTop: "15px" }}
                            international
                            defaultCountry="US"
                            value={formik.values.phone}
                            onChange={(value) => formik.setFieldValue("phone", value)}
                            inputComponent={ForwardedInput}
                            onBlur={() => formik.setFieldTouched("phone", true)}
                        />
                        {formik.touched.phone && formik.errors.phone && (
                            <div className="text-danger small mt-1">{formik.errors.phone}</div>
                        )}



                        {/* <FormGroup>
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="ni ni-lock-circle-open" />
                                    </InputGroupText>
                                </InputGroupAddon>

                                <Input
                                    placeholder="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete="new-password"
                                    name="password"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />

                                <InputGroupAddon addonType="append">
                                    <InputGroupText
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowPassword((prev) => !prev)}
                                    >
                                        <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>

                            {formik.touched.password && formik.errors.password && (
                                <div className="text-danger small mt-1">{formik.errors.password}</div>
                            )}
                        </FormGroup> */}









                        <div className="text-center">
                            <Button className="my-4" color="primary" type="submit" disabled={formik.isSubmitting}>
                                {formik.isSubmitting ? "Submitting..." : "Submit"}
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default AddUser;
